<nav class="navbar navbar-expand-lg cus-nav-bar navbar-fixed-top flex justify-content-between">
    <span class="hamburger" (click)="onToggleSideNav()" *ngIf="!isSideBarOpen">
        ☰
    </span>
    <div class="hamburger" (click)="onToggleSideNav()" *ngIf="isSideBarOpen">
        X
    </div>
    <span class="cine-awards-nav-header"  [ngClass]="{'header_container': isArchive}">cinejoy</span>
    <span>
        <div class="form-floating" fxHide.xs fxHide.sm *ngIf="isArchive">
            <select class="form-select" id="floatingSelect" [(ngModel)]="version"
                aria-label="Floating label select example" (change)="onChangeVersion($event)" style="width: 200px;height: 55px;">
                <option value="">Choose Award Version</option>
                <option *ngFor="let level of allVersions" [value]="level.id">{{level.awardsVersion}}</option>
            </select>
            <label for="floatingSelect" class="value-label">Choose Version</label>
        </div>
    </span>
</nav>
<app-sidebar [secNavOpen]="true" [showHeader]="false" *ngIf="isSideBarOpen"></app-sidebar>

<div class="main-container">
    <div class="mt-5" fxShow.xs fxShow.sm fxHide.md fxHide.lg fxHide.xl *ngIf="isArchive">
        <div class="form-floating">
            <select class="form-select" id="floatingSelect" [(ngModel)]="version"
                aria-label="Floating label select example" (change)="onChangeVersion($event)">
                <option value="">Choose Award Version</option>
                <option *ngFor="let level of allVersions" [value]="level.id">{{level.awardsVersion}}</option>
            </select>
            <label for="floatingSelect" class="value-label">Choose Version</label>
        </div>
    </div>
    <div class="judge-list">
        <div style="display: flex;flex-direction: row;justify-content: space-between;margin-left: 12px;">

            <div class="header" style="display: flex;flex-direction: column;">
                <i class="bi bi-arrow-left" style="cursor: pointer;" (click)="navigateBack()"></i>
                <h1 class="awards-title mt-2">JUDGES</h1>
                <div class="header-border"></div>
            </div>

        </div>
        <div class="sub-text">
            Get to know the featured guests and distinguished luminaries who will be attending and judging the entries
            this year.
        </div>
        <div>
            <div fxLayout="row wrap" *ngIf="juryList.cinejoyJudges">
                <ng-container *ngFor="let item of juryList.cinejoyJudges; let i = index">
                    <div fxLayout="column wrap" fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" class="p-0"
                        [ngClass]="{'selected': selectedIndex == i}" (click)="onClickOfItem(item, i)">
                        <div class="card award-winners-card p-0" [ngClass]="{'selectedItem':selectedIndex == i}"
                            [ngStyle]="selectedIndex == i ? {'background-color': '#D7BE69'} : {'background-color': 'white'}">
                            <img class="card-img-top ml-2" [src]="item.thumbnail" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title">{{item.name}}</h5>
                                <p class="card-text">{{item.designation}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="mobile-profile" *ngIf="selectedIndex == i" fxHide.md fxHide.lg>
                        <div class="sub-text p-4">
                            <div class="card">
                                <img class="card-img" [src]="selectedJury?.thumbnail" alt="Card image cap">
                                <div class="card-body">
                                    <h2 class="card-title">{{selectedJury?.name}}</h2>
                                    <h3 class="card-title">{{selectedJury?.designation}}</h3>

                                    <p class="card-text">{{selectedJury?.bio}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>
            <div *ngIf="!juryList?.cinejoyJudges?.length" class="nowinner">
                <span>No Award Jury Found For the selected version.</span>
            </div>
        </div>
    </div>
    <div class="profile" *ngIf="selectedJury">
        <div class="sub-text p-4">
            <div class="card">
                <img class="card-img" [src]="selectedJury?.thumbnail" alt="Card image cap" style="height: 400px;">
                <div class="card-body">
                    <h2 class="card-title mb-0">{{selectedJury?.name}}</h2>
                    <h3 class="card-title">{{selectedJury?.designation}}</h3>

                    <p class="card-text">{{selectedJury?.bio}}</p>
                </div>
            </div>
        </div>
    </div>
</div>